import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    pcNewlist:[]
  },
  getters:{
    isLogin: state => state.isLogin,
    pcNewlist:state=>state.pcNewlist
  },
  mutations: {
    userStatus(state, flag){
      state.isLogin = false
    },
    changePcNewlistMut(state,params){
      state.pcNewlist = params
    }
  },
  actions: {
    userLogin({commit},flag){
      commit("userStatus", flag)
    },
    changePcNewlistAct({commit},params){
      commit("changePcNewlistMut", params)
    }
  },
  modules: {
  }
})
